<star-rating 
[value]='ratingValue' 
[totalstars]='settings.totalStars' 
[checkedcolor]='settings.checkedColor' 
[uncheckedcolor]='settings.uncheckedColor' 
[size]='settings.size' 
[readonly]='settings.readOnly' 
(rate)="onRate($event)"></star-rating>
